const t = {
  name: "FundsIn",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 0V8.58569L15.9999 5.58578L17.4141 7L11.9999 12.4142L6.58569 7L7.99991 5.58578L11 8.58588V0H13Z" fill="currentColor"/>
<path d="M18 18H6V20H18V18Z" fill="currentColor"/>
<path d="M6 14H18V16H6V14Z" fill="currentColor"/>
<path d="M4 21V8H2V21C2 22.6523 3.34772 24 5 24H19C20.6523 24 22 22.6523 22 21V8H20V21C20 21.5477 19.5477 22 19 22H5C4.45228 22 4 21.5477 4 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as FundsIn
};
